var _ref2, _ref3;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgPlus = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Group_18215",
      "data-name": "Group 18215",
      width: 15.798,
      height: 15.798,
      viewBox: "0 0 15.798 15.798",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("defs", null,
    /*#__PURE__*/
    React.createElement("clipPath", {
      id: "clip-path"
    },
    /*#__PURE__*/
    React.createElement("rect", {
      id: "Rectangle_76566",
      "data-name": "Rectangle 76566",
      width: 15.798,
      height: 15.798,
      transform: "translate(0 0)"
    })))), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_16841",
      "data-name": "Group 16841",
      clipPath: "url(#clip-path)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22383",
      "data-name": "Path 22383",
      d: "M14.324,6.425H9.374V1.475a1.474,1.474,0,1,0-2.949,0v4.95H1.474a1.474,1.474,0,0,0,0,2.949H6.425v4.949a1.474,1.474,0,1,0,2.949,0V9.374h4.95a1.474,1.474,0,0,0,0-2.949"
    }))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Plus.b7f57571.svg";
export { ForwardRef as ReactComponent };